<template>
  <form-products
      :products.sync="incomingInvoice.products"
      @changePreTaxAmount="$emit('changePreTaxAmount')"
      @isProductMounted="$emit('isProductMounted')"
  />
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import FormProducts from '../../../form/products/Products'

export default {
  components: {
    FormProducts
  },
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>